import { library } from '@fortawesome/fontawesome-svg-core';
import {
  faList,
  faMapMarked,
  faTh,
  faCheckCircle,
  faExclamationTriangle,
  faExclamationCircle,
  faBell,
  faCircle,
  faWrench,
  faSearch,
  faPlus,
  faUndo,
  faCloudUploadAlt,
  faDownload,
  faSync,
  faCommentDots,
  faQuestionCircle,
  faCopy,
  faArrowRight,
  faCog,
  faUserCog,
  faToolbox,
  faTrash,
  faPencilAlt,
  faEdit,
  faMinusCircle,
  faCheck,
  faBan,
  faEllipsisH,
  faChevronCircleUp,
  faExchangeAlt,
  faPlay,
  faSignInAlt,
  faCloudDownloadAlt,
  faTimes,
  faCogs,
  faMicrochip,
  faArrowAltCircleRight,
  faDatabase,
  faInfoCircle,
  faBriefcase,
  faHdd,
  faFolder,
  faServer,
  faRegistered,
  faWifi,
  faThList,
  faCompressAlt,
  faListCheck,
  faTable,
  faTableCells,
  faSquareCheck,
  faSquareMinus,
} from '@fortawesome/free-solid-svg-icons';

library.add(faList);
library.add(faMapMarked);
library.add(faTh);
library.add(faCheckCircle);
library.add(faExclamationCircle);
library.add(faExclamationTriangle);
library.add(faBell);
library.add(faCircle);
library.add(faWrench);
library.add(faSearch);
library.add(faPlus);
library.add(faUndo);
library.add(faCloudUploadAlt);
library.add(faDownload);
library.add(faSync);
library.add(faCommentDots);
library.add(faQuestionCircle);
library.add(faCopy);
library.add(faArrowRight);
library.add(faCog);
library.add(faUserCog);
library.add(faToolbox);
library.add(faTrash);
library.add(faPencilAlt);
library.add(faEdit);
library.add(faMinusCircle);
library.add(faCheck);
library.add(faBan);
library.add(faEllipsisH);
library.add(faChevronCircleUp);
library.add(faExchangeAlt);
library.add(faPlay);
library.add(faSignInAlt);
library.add(faCloudDownloadAlt);
library.add(faTimes);
library.add(faCogs);
library.add(faMicrochip);
library.add(faArrowAltCircleRight);
library.add(faDatabase);
library.add(faInfoCircle);
library.add(faServer);
library.add(faBriefcase);
library.add(faHdd);
library.add(faFolder);
library.add(faRegistered);
library.add(faWifi);
library.add(faThList);
library.add(faCompressAlt);
library.add(faListCheck);
library.add(faTable);
library.add(faTableCells);
library.add(faSquareCheck);
library.add(faSquareMinus);